import React from "react";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { Search } from "@mui/icons-material";
import {
  FiltersSection,
  SearchInputWrapper,
  SearchInput,
  SearchIcon,
  FilterButtons,
  FilterButton,
} from "./styled";

export type StatusFilter = "all" | "healthy" | "stale" | "inactive";

export const SearchAndFilters: React.FC<{
  searchTerm: string;
  onSearchChange: (term: string) => void;
  statusFilter: StatusFilter;
  onStatusFilterChange: (filter: StatusFilter) => void;
  computerCount: number;
}> = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  computerCount,
}) => {
  const { t } = useTranslation();

  return (
    <FiltersSection>
      <SearchInputWrapper>
        <SearchIcon>
          <Search style={{ fontSize: "20px" }} />
        </SearchIcon>
        <SearchInput
          type="text"
          placeholder={t(messages.Search_computers_placeholder())}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </SearchInputWrapper>

      <FilterButtons>
        <FilterButton
          active={statusFilter === "all"}
          onClick={() => onStatusFilterChange("all")}
        >
          {t(messages.All())} ({computerCount})
        </FilterButton>
        <FilterButton
          active={statusFilter === "healthy"}
          onClick={() => onStatusFilterChange("healthy")}
        >
          {t(messages.Healthy())}
        </FilterButton>
        <FilterButton
          active={statusFilter === "stale"}
          onClick={() => onStatusFilterChange("stale")}
        >
          {t(messages.Stale())}
        </FilterButton>
        <FilterButton
          active={statusFilter === "inactive"}
          onClick={() => onStatusFilterChange("inactive")}
        >
          {t(messages.Inactive())}
        </FilterButton>
      </FilterButtons>
    </FiltersSection>
  );
};
